<template>
  <div>
    <div class="bg-blue-grey-100 p-30" v-if="!currentTerminateMode">
      <h5 class="title">Do you want to Terminate {{team.name}} Team?</h5>
      <p>After Terminated, {{team.name}} Team will not be able to access ByteArk Account and use any service.</p>
      <button v-on:click.stop="onSubmit(true)" class="btn btn-danger btn-outline">
        Terminate team<span class="glyphicon"></span>
      </button>
    </div>
    <div class="bg-red-600 p-30" v-else>
      <h5 class="title white">{{team.name}} is currently Terminated , Do you want to Activate {{team.name}} Team?</h5>
      <p class="white">After Activated, {{team.name}} Team will be able to access ByteArk Account and use any service.</p>
      <button v-on:click.stop="onSubmit(false)" class="btn btn-default white btn-outline">
        Activate team<span class="glyphicon"></span>
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    LoadingIndicator,
  },
  props: {
    team: {
      type: Object,
    },
  },
  data: function () {
    return {
      isLoading: false,
      currentTerminateMode: false,
    };
  },
  created: function() {
    this.currentTerminateMode = this.team.is_terminated;

    this.isLoading = true;
  },
  mounted: function() {
    if (this.team) {
      this.currentTerminateMode = this.team.is_terminated;
    }
  },
  methods: {
    onSubmit: function (value) {
      let title = '';
      let text = '';
      let btnConfirm = '';

      if (value) {
        title = 'Are you sure to Terminate this team?';
        text = `After Terminate, ${this.team.name} Team will not be able to access ByteArk Account and use any service.`;
        btnConfirm = 'Yes, Terminate it';
      } else {
        title = 'Are you sure to Activate this team?';
        text = `After Activated, ${this.team.name} Team will be able to access ByteArk Account and use any service.`;
        btnConfirm = 'Yes, Activate it';
      }

      swal({
        title: title,
        text: text,
        showCancelButton: true,
        confirmButtonColor: '#00A6ED',
        cancelButtonColor: '#c6d3d7',
        confirmButtonText: btnConfirm,
        closeOnConfirm: true,
      }).then(() => {
        const url = `api/admin/terminate-team`;
        axios.post(url, {
          namespace: this.team.namespace,
          is_terminated: value,
        })
        .then((response) => {
          // repalce with new item that complate deactive
          this.currentTerminateMode = response.data.is_terminated;
          let textSuccess = '';

          if (this.currentTerminateMode) {
            textSuccess = `${this.team.name} have been terminated`;
          } else {
            textSuccess = `${this.team.name} have been activated`;
          }

          swal(
            'Success',
            textSuccess,
            'success'
          );
        })
        .catch(() => {

        });
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TeamTerminate.vue?092abdf0